import React from 'react';
import locales from '../../locales/LocalesManager';
import properties from '../../constants/Properties';
import mouseUtils from '../utils/MouseUtils';
import platformDetection from '../utils/PlatformDetection';
import appParameters from '../utils/AppParameters';
import createShapes from '../utils/CreateShapes';
import dragManager from '../utils/DragManager';
import { ScrollableComponent } from '../menus/ScrollableComponent';
import Draggable from 'react-draggable';
import { getTouchPosition } from '../utils/TransformToolUtils';
import modeType from '../../constants/ModeConstants';
import storeManager from '../../store/StoreManager';
import { changeContextMode } from '../../actions/MenuActions';
import textEditorUtils from './textEditorTool/utils/TextEditorUtils';

const Title = React.createClass({
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const dispatch = storeManager.getStore().dispatch;

        dispatch(changeContextMode(modeType.CONTEXT_NONE));
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.accordionWidth != newProps.accordionWidth)
            return true;
        else
            return false;
    },
    render() {
        const titleStyle = {
            position: 'absolute',
            backgroundColor: properties.BROWSER_SELECTED_COLOR,
            width: this.props.accordionWidth,
            height: properties.CLIPART_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 20,
            top: 0
        };

        const spanStyle = {
            color: 'white',
            fontSize: 16,
            cursor: 'default',
            position: 'absolute',
            top: 6
        };

        var caption = locales.getCaption('mainMenuText', 'hover');

        var closeButtonStyle = {
            position: 'absolute',
            width: 24,
            height: 24,
            top: 3,
            right: 28,
            cursor: 'pointer',
            borderStyle: 'none',
            background: 'none',
        };

        const closeStyle = {
            position: 'absolute',
            width: 15,
            top: 4,
            right: 4,
            cursor: 'pointer'
        };

        var ariaLabel = locales.getCaption('exit', 'other') + ' ' + caption;

        return (
            <div style={titleStyle}>
                <span style={spanStyle}>{caption}</span>
                <button id="leftTextMenuFirstFocusabletElement" aria-label={ariaLabel} style={closeButtonStyle} onClick={this.onClick} onTouchEnd={this.onClick}>
                    <img alt='' aria-hidden='true' style={closeStyle} src={appParameters.RESOURCES_LOCATION() + 'assets/exit_edit.png'}/>
                </button>
            </div>
        );
    }
});

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false,
            clientX: 0,
            clientY: 0
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    createShape (topLeftPosition) {
        const { dispatch } = this.props;
        const isRichText = textEditorUtils.useRichText();

        switch (this.props.index) {
            case 0: {
                createShapes.createTextBoxSimple(dispatch, topLeftPosition, isRichText);
                break;
            }

            case 1: {
                createShapes.createTextBox(dispatch, topLeftPosition, isRichText);
                break;
            }

            case 2: {
                createShapes.createSpeachBubble(dispatch, topLeftPosition, isRichText);
                break;
            }

            case 3: {
                createShapes.createThoughtBubble(dispatch, topLeftPosition, isRichText);
                break;
            }

            case 4: {
                createShapes.createScreamBubble(dispatch, topLeftPosition, isRichText);
                break;
            }

            case 5: {
                createShapes.createComplexSpeachBubble(dispatch, topLeftPosition, isRichText);
                break;
            }

            case 6: {
                createShapes.createMindMapShape(dispatch, topLeftPosition, isRichText);
                break;
            }
        }
    },
    onMouseDown(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (platformDetection.isIOS()) {
            this.createShape();
            return;
        }

        const clientPosition = mouseUtils.getTouchPosition(e);

        this.setState({
            clientX: clientPosition.x,
            clientY: clientPosition.y
        });
    },
    onMouseUp(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (platformDetection.isIOS())
            return;

        const clientPosition = mouseUtils.getTouchPosition(e);

        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5)
            this.createShape();
    },
    onMouseClick(e) {
        var downTime = new Date().getTime() - mouseUtils.mouseDownTime;

        if (downTime < 1000)
            return;

        this.createShape();
    },
    onDragStart(e, coreEvent) {
        if (platformDetection.isTouchableDevice() == true)
            return;

        mouseUtils.mouseDownTime = new Date().getTime();

        const clone = this.refs.itemRenderer;

        dragManager.prepareClone(clone, this.createShape, getTouchPosition(e));
    },
    onDragMove(e, coreEvent) {
        if (platformDetection.isTouchableDevice() == true)
            return;

        dragManager.onDragMove(coreEvent.lastX, coreEvent.lastY);
    },
    onDragEnd(e, coreEvent) {
        if (platformDetection.isTouchableDevice() == true)
            return;

        dragManager.onDragEnd(coreEvent.lastX, coreEvent.lastY);
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isOver != nextState.isOver || this.state.isMouseIn != nextState.isMouseIn)
            return true;
        else
            return false;
    },
    getButtonAriaLabel() {
        var text = '';

        switch (this.props.index) {
            case 0: {
                // text = 'Tekstboks uten ramme';
                text = locales.getCaption('TextBoxSimpleAriaLabel', 'other');
                break;
            }

            case 1: {
                // text = 'Tekstboks med ramme';
                text = locales.getCaption('TextBoxAriaLabel', 'other');
                break;
            }

            case 2: {
                // text = 'Snakkeboble';
                text = locales.getCaption('SpeechAriaLabel', 'other');
                break;
            }

            case 3: {
                // text = 'Tankeboble';
                text = locales.getCaption('ThoughtBubbleAriaLabel', 'other');
                break;
            }

            case 4: {
                // text = 'Ropeboble';
                text = locales.getCaption('ScreamBubbleAriaLabel', 'other');
                break;
            }

            case 5: {
                // text = 'Snakkeboble med flere haler';
                text = locales.getCaption('ComplexSpeechBubbleAriaLabel', 'other');
                break;
            }

            case 6: {
                text = locales.getCaption('MindMapShape', 'text');
                break;
            }
        }

        return text;
    },
    render() {
        var horizontalGap = 40;

        if (platformDetection.isIOS() == true)
            horizontalGap = 20;

        const topPadding = 0;
        const verticalGap = 15;
        const buttonWidth = (properties.BROWSER_WIDTH - 3 * horizontalGap) / 2;
        const buttonHeight = buttonWidth;
        var leftPosition;
        var topPosition;

        if (this.props.index  == 0 || this.props.index == 2 || this.props.index == 4 || this.props.index == 6)
            leftPosition = horizontalGap;
        else
            leftPosition = 2 * horizontalGap + buttonWidth;

        if (this.props.index  == 0 || this.props.index == 1)
            topPosition = verticalGap + topPadding;
        else
        if (this.props.index  == 2 || this.props.index == 3)
            topPosition = 2 * verticalGap + buttonHeight + topPadding;
        else
        if (this.props.index  == 4 || this.props.index == 5)
            topPosition = 3 * verticalGap + 2 * buttonHeight + topPadding;
        else
            topPosition = 4 * verticalGap + 3 * buttonHeight + topPadding;

        var frameDisplayState;
        var frameColor;

        if (this.state.isOver == true) {
            frameDisplayState = 'block';
            frameColor = properties.SLIDE_FRAME_HOVER_COLOR;
        } else {
            frameDisplayState = 'none';
            frameColor = 'black';
        }

        const boderWidth = 2;

        const frameStyle = {
            position: 'absolute',
            width: buttonWidth - 2 * boderWidth,
            height: buttonHeight - 2 * boderWidth,
            borderWidth: boderWidth,
            borderStyle: 'solid',
            borderColor: frameColor,
            top: 0,
            display: frameDisplayState
        };

        var buttonStyle = {
            position: 'absolute',
            left: leftPosition,
            top: topPosition,
            width: buttonWidth,
            height: buttonHeight,
            cursor: '-webkit-grab',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            background: 'none',
            display: 'flex',
            borderStyle: 'none'
        };

        const iconStyle = {
            position: 'absolute',
            width: buttonWidth,
            height: buttonHeight
        };

        var spanStyle = {
            position: 'absolute',
            width: buttonWidth - 10,
            textAlign: 'center',
            left: 5,
            top: 30,
            fontSize: 14,
            cursor: 'default',
            color: frameColor
        };

        const draggableStyle = {
            position: 'absolute',
            width: buttonWidth,
            height: buttonHeight,
            top: 0,
            background: 'red',
            opacity: 0
        };

        if (platformDetection.isIOS() == true) {
            spanStyle.fontSize = 12;
            spanStyle.top = 20;
        }

        var idValue;

        if (this.props.index == 6)
            idValue = 'leftTextMenuLastFocusableElement';

        return (
            <button id={idValue} ref='itemRenderer' aria-label={this.getButtonAriaLabel()} style={buttonStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onClick={this.onMouseClick} onTouchStart={this.onMouseDown} onTouchEnd={this.onMouseUp}>
                <img alt='' aria-hidden='true' style={iconStyle} src={this.props.src}/>
                <span style={spanStyle}>{this.props.text}</span>
                <div style={frameStyle}/>
                <Draggable axis='none' position={{x:0, y:0}} onStart={this.onDragStart} onDrag={this.onDragMove} onStop={this.onDragEnd}>
                    <div style={draggableStyle}/>
                </Draggable>
            </button>
        );
    }
});

export const LeftTextMenu = React.createClass({
    getInitialState() {
        return {
            buttons: []
        };
    },
    componentDidMount() {
        this.initElements();

        if (platformDetection.isIOS())
            return;

        setTimeout(function() {
            var element = document.getElementById('leftTextMenuFirstFocusabletElement');

            if (element)
                element.focus();
        }.bind(this), 30);
    },
    initElements() {
        var buttons = [];

        buttons.push(<Button index={0} dispatch={this.props.dispatch} text={locales.getCaption('TextSimple', 'text')} src={appParameters.RESOURCES_LOCATION() + 'assets/simpleText.png'} key='textMenu0'/>);
        buttons.push(<Button index={1} dispatch={this.props.dispatch} text={locales.getCaption('TextShape', 'text')} src={appParameters.RESOURCES_LOCATION() + 'assets/textBoxIcon.png'} key='textMenu1'/>);
        buttons.push(<Button index={2} dispatch={this.props.dispatch} text={locales.getCaption('SpeechShape', 'text')}  src={appParameters.RESOURCES_LOCATION() + 'assets/speachBubble.png'} key='textMenu2'/>);
        buttons.push(<Button index={3} dispatch={this.props.dispatch} text={locales.getCaption('ThoughtShape', 'text')}  src={appParameters.RESOURCES_LOCATION() + 'assets/thoughtBubble.png'} key='textMenu3'/>);
        buttons.push(<Button index={4} dispatch={this.props.dispatch} text={locales.getCaption('ScreamShape', 'text')}  src={appParameters.RESOURCES_LOCATION() + 'assets/screamBubble.png'} key='textMenu4'/>);
        buttons.push(<Button index={5} dispatch={this.props.dispatch} text={locales.getCaption('ComplexSpeechShape', 'text')}  src={appParameters.RESOURCES_LOCATION() + 'assets/complexSpeachBubble.png'} key='textMenu5'/>);

        if (textEditorUtils.useRichText())
            buttons.push(<Button index={6} dispatch={this.props.dispatch} text={locales.getCaption('MindMapShape', 'text')}  src={appParameters.RESOURCES_LOCATION() + 'assets/mindMap.png'} key='textMenu6'/>);

        this.setState({
            buttons
        });
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.buttons != nextState.buttons || this.props.windowHeight != newProps.windowHeight || this.props.accordionWidth != newProps.accordionWidth)
            return true;
        else
            return false;
    },
    render() {
        if (this.state == undefined || this.state.buttons == undefined)
            return (<div/>);

        const menuStyle = {
            position: 'absolute',
            top: 0,
            right: 0,
            width: this.props.accordionWidth,
            height: this.props.windowHeight,
            overflowX: 'hidden',
            overflowY: 'hidden',
            backgroundColor: 'white'
        };

        var listHeight = this.props.windowHeight - properties.CLIPART_BUTTON_HEIGHT;
        var componentProperties = {};

        componentProperties.paddingTop = 0;
        componentProperties.paddingLeft = 0;
        componentProperties.width = this.props.accordionWidth;
        componentProperties.height = listHeight;
        componentProperties.top = properties.CLIPART_BUTTON_HEIGHT;
        componentProperties.displayState = 'block';
        componentProperties.elements = this.state.buttons;

        const verticalGap = 5;
        var horizontalGap = platformDetection.isIOS() ? 10 : 20;
        const buttonWidth = (properties.BROWSER_WIDTH - 3 * horizontalGap) / 2;

        componentProperties.scrollHeight = 3 * buttonWidth + 3 * verticalGap;

        return (
            <div style={menuStyle} id="leftTextMenu">
                <Title accordionWidth={this.props.accordionWidth}/>
                <ScrollableComponent componentProperties={componentProperties}/>
            </div>
        );
    }
});


/** WEBPACK FOOTER **
 ** ./src/components/menus/LeftTextMenu.js
 **/